export default "__VITE_ASSET__FygFHcTJ__"